<template>
  <div class="zy-container icons wow fadeInDown" style="margin-top: 40px;">
    <TitleDesc title="与时俱进 独具一格"
               desc="强大的技术支撑高强度更新迭代，团队始终坚持创新 紧随时代潮流 提供最高效系统服务客户"/>
    <div class="bk">
      <div class="bk-item  wow fadeInDown hvr-float" v-for="(icon, idx) in icons" :key="idx" :data-wow-delay="idx * 0.2 + 's'">
        <el-image :src="icon.icon" class="icon"  />
        <div>{{icon.desc}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleDesc from "@/views/index/widgets/TitleDesc.vue";
import { WOW } from "wowjs";

export default {
  name: "Icons",
  components: {TitleDesc},
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  data() {
    return {
      icons: [
        {icon: require('@/assets/images/index/icons/icon1.png'), desc: '全网唯一支持多国际化语言包支持不同国家语备份'},
        {icon: require('@/assets/images/index/icons/icon2.png'), desc: '行业唯一独立研发的聊天IM系统，可以实现聊天、发红包等'},
        {icon: require('@/assets/images/index/icons/icon3.png'), desc: '无需购买源码轻松实现二次开发,省大量成本'},
        {icon: require('@/assets/images/index/icons/icon4.png'), desc: '全新微服务架构每个模块可以独立部署'},
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.icons {
  .bk {
    display: flex;

    .bk-item {
      //height: 458px;
      background: #F9FDFF;
      box-shadow: 0px 0px 23px 0px rgba(187,206,225,0.62), inset 0px 0px 18px 0px #FFFFFF;
      border-radius: 14px;
      border: 2px solid #FFFFFF;
      flex: 1;
      margin: 8px;
      padding: 40px;
      text-align: center;
      .icon {
        width: 100%;
        //height: 250px;
      }
      .title {
        margin-top: 20px;
        font-size: 24px;
        color: #333333;
        line-height: 33px;
      }
    }
  }
}
.hvr-float {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.hvr-float:hover, .hvr-float:focus, .hvr-float:active {
  -webkit-transform: translateY(-8px);
  transform: translateY(-8px);
}
</style>
